import { Component } from '@angular/core';
import { FilterService } from '../filter/service/filter.service';
import {HeaderComponent} from "../header/header.component";
import {SearchFilterComponent} from "../filter/search-filter.component";
import {NgIf} from "@angular/common";
import { ActivatedRoute, NavigationStart, Router, RouterOutlet } from "@angular/router";
import {FooterComponent} from "../footer/footer.component";
import { ChatbotComponent } from "./chatbot/chatbot.component";
import { filter } from "rxjs";
import { trim } from "lodash-es";

@Component({
    selector: 'app-concierge-app',
    templateUrl: './concierge-app.component.html',
    styleUrls: ['./concierge-app.component.scss'],
    imports: [
        HeaderComponent,
        SearchFilterComponent,
        NgIf,
        RouterOutlet,
        FooterComponent,
        ChatbotComponent
    ]
})
export class ConciergeAppComponent {

  isSearchPage = false;
  isHomePage = false;

  constructor(public filterService: FilterService, router: Router) {
    this.onRouteChange(router.url);
    router.events.pipe(filter(v=>v instanceof NavigationStart)).subscribe(event => {
      let path = (event as NavigationStart).url;
      this.onRouteChange(path);
    });
  }

  private onRouteChange(path: string) {
    const paramIndex = path.indexOf('?');
    if (paramIndex !== -1) {
      path = path.substring(0, paramIndex);
    }
    path = trim(path, '/');
    const url = path.split('/');

    this.isSearchPage = url[1] === 'list';
    this.isHomePage = !url[1];
  }
}
